<template>
  <div class="btn" v-if="(config && (!config.hide || (data && !data.hide)))">
    <el-button :title="title" :type="type || 'text'" :size="size" :plain="plain" :icon="icon" :round="round"
      :circle="!!icon || !!img" :disabled="disabled || data.DISABLED" :class="config.class" @click="onCallback">
      <span v-if="!icon && !img">{{ title }}</span>
      <img v-if="img" :src="isHover ? (unimg || img) : img" @mousemove="isHover = true" @mouseout="isHover = false" />
    </el-button>
  </div>
</template>

<script>
export default {
  name: "Btn",
  props: {
    config: Object,
    data: Object,
  },
  data() {
    return {
      img: this.config && this.config.img,
      unimg: this.config && this.config.unimg,
      icon: this.config && this.config.icon,
      title: this.config && this.config.title,
      type: this.config && this.config.type,
      size: this.config && this.config.size,
      plain: this.config && this.config.plain,
      round: this.config && this.config.round,
      disabled: this.config && this.config.disabled,
      isHover: false,
    };
  },
  methods: {
    onCallback() {
      if (typeof this.config.cb == "function") {
        this.config.cb(this.data);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.btn {
  display: inline-block;

  &+.btn {
    margin-left: 10px;
  }

  /deep/ .el-button {
    &.is-circle {
      padding: 5px;
      color: #96999f;
      background: #f2f6fc;
    }

    &:hover {
      color: #fff;
      background-color: #2691FF;
    }

    &.delbtn:hover {
      background-color: #f56c6c;
    }

    >span {
      display: inline-block;
      position: relative;
      min-width: 14px;
      height: 12px;

      >img {
        cursor: pointer;
        position: absolute;
        left: -6px;
        top: -6px;
      }
    }
  }
}

/deep/ .el-dialog .btns .mians .quxiao {
  border: 1px solid #ddd;
}
</style>
